<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    item-text="title"
    :items="factorList"
    item-value="id"
    clearable
    @change="onChange"
    return-object
    v-on:input="$emit('input', $event)"
  ></v-autocomplete>
</template>

<script>
import { Factor } from '@/plugins/api'

export default {
  data: () => ({
    factors: []
  }),
  props: {
    filter: Object
  },
  computed: {
    factorList() {
      return this.factors.map(c => ({ ...c, title: `${c.title}` }))
    }
  },
  created() {},
  methods: {
    async fetchFactor() {
      this.factors = await Factor.fetch({
        ...this.filter,
        _sort: 'index:ASC'
      })
    },
    onChange(data) {
      this.$emit('change', data)
    }
  },
  watch: {
    filter(filters) {
      this.fetchFactor()
    }
  }
}
</script>
